import { css } from '@compiled/react';

import { token } from '@atlaskit/tokens';

const containerStyles = css({
	position: 'relative',
	display: 'inline-flex',
	alignItems: 'center',
	justifyContent: 'center',
	borderRadius: '50%',
	flexShrink: 0,
});

const textStyles = css({
	color: token('color.text.inverse', '#FFFFFF'),
	fontWeight: 600,
	lineHeight: 1,
	userSelect: 'none',
});

type Props = {
	initials: string;
	backgroundColor: string;
	size?: number;
	fontSize?: number;
};

export const JfindIllustrationInitialsAvatar = ({
	initials,
	backgroundColor,
	size = 24,
	fontSize = 9,
}: Props) => (
	<div
		css={containerStyles}
		// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, local/ensure-wac-token-usage
		style={{ width: size, height: size, backgroundColor }}
	>
		{/* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop */}
		<span css={textStyles} style={{ fontSize }}>
			{initials}
		</span>
	</div>
);
